import ajax from "../utils/request";

const activeApi = {
    /********************************活动列表*********************************** */
    // 活动列表
    getWebActivity(params) {
        return ajax({
            url: "/activity/list",
            type: "get",
            params: params,
        });
    },
    commentReq(data) {
        return ajax({
            url: "/comment/access",
            type: "post",
            params: data,
        });
    },
    batchModifyCoinAndRemoveSelf(params) {
        return ajax({
            url: "/vid/removed",
            type: "post",
            params: params,
        });
    },
    batchModifyNesType(params) {
        return ajax({
            url: "/vid/changetype",
            type: "post",
            params: params,
        });
    },
    batchModifyCoinAndRemoves(params) {
        return ajax({
            url: "/vid/deletes",
            type: "post",
            params: params,
        });
    },
    //编辑活动
    editWebActive(params) {
        return ajax({
            url: "/activity/update",
            type: "post",
            params: params,
        });
    },
    /********************************活动奖品列表*********************************** */
    /**
     * 奖品列表
     * @param {object} [params]            - 需要的参数
     * @param {string} [params.actID]      - 活动id
     * @param {number} [params.pageNumber] - 页码【从1开始计数】
     * @param {number} [params.pageSize]   - 每页显示的条数【从1开始计数】
     */
    getActivityPrize(params) {
        return ajax({
            url: "/activity/reward/list",
            type: "get",
            params: params,
        });
    },
    /**
     * 新增奖品
     * @param {object} [params]            - 需要的参数
     * @param {string} [params.actID]      - 活动id
     * @param {number} [params.pageNumber] - 页码【从1开始计数】
     * @param {number} [params.pageSize]   - 每页显示的条数【从1开始计数】
     */
    addActivityPrize(params) {
        return ajax({
            url: "/activity/reward/add",
            type: "post",
            params: params,
        });
    },
    /**
     * 编辑奖品
     * @param {object} [params]            - 需要的参数
     * @param {string} [params.actID]      - 活动id
     * @param {number} [params.pageNumber] - 页码【从1开始计数】
     * @param {number} [params.pageSize]   - 每页显示的条数【从1开始计数】
     */
    editActivityPrize(params) {
        return ajax({
            url: "/activity/reward/modify",
            type: "post",
            params: params,
        });
    },
    /********************************兑换码列表*********************************** */
    // 兑换码列表
    redemptionCodeList(params) {
        return ajax({
            url: "/exchange/code/list",
            type: "get",
            params: params,
        });
    },
    // 添加兑换码
    addCode(params) {
        return ajax({
            url: "/exchange/code/add",
            type: "post",
            params: params,
        });
    },
    // 修改兑换码
    editCode(params) {
        return ajax({
            url: "/exchange/code/update",
            type: "post",
            params: params,
        });
    },
    // 删除兑换码
    delCode(params) {
        return ajax({
            url: "/exchange/code/del",
            type: "delete",
            params: params,
        });
    },
    /********************************兑换码兑换日志*********************************** */
    redemptionLogList(params) {
        return ajax({
            url: "/exchange/log/list",
            type: "get",
            params: params,
        });
    },

    /********************************获奖记录列表（嫩模活动）*********************************** */

    //添加获奖记录列表
    addWinRecord(params) {
        return ajax({
            url: "/newactivity/addWinRecord",
            type: "post",
            params: params,
        });
    },

    //导入所有嫩模
    importModels(params) {
        return ajax({
            url: "/newactivity/importModels",
            type: "post",
            params: params,
        });
    },

    //写入参数活动人数
    updateJoinNum(params) {
        return ajax({
            url: "/newactivity/updateJoinNum",
            type: "post",
            params: params,
        });
    },
    //
    // 嫩模获奖记录
    winRecordPage(params) {
        return ajax({
            url: "/newactivity/winRecordPage",
            type: "post",
            params: params,
        });
    },

    /********************************购买列表*********************************** */

    //购买列表
    buyPage(params) {
        return ajax({
            url: "/newactivity/buyPage",
            type: "post",
            params: params,
        });
    },

    /******************************** 摇奖号列表*********************************** */

    //请求列表
    getLottery(params) {
        return ajax({
            url: "/lottnum/list",
            type: "get",
            params: params,
        });
    },

    /********************************兑换码类型*********************************** */
    // 兑换码类型列表
    // redemptionTypeList(params) {
    //   return ajax({
    //     url: '/exchange/type/list',
    //     type: 'get',
    //     params: params
    //   })
    // },
    // // 添加兑换码类型
    // addType(params) {
    //   return ajax({
    //     url: '/exchange/type/add',
    //     type: 'post',
    //     params: params
    //   })
    // },
    // // 删除兑换码类型
    // delType(params) {
    //   return ajax({
    //     url: '/exchange/type/del',
    //     type: 'delete',
    //     params: params
    //   })
    // },
    // // 修改兑换码类型
    // editType(params) {
    //   return ajax({
    //     url: '/exchange/type/update',
    //     type: 'post',
    //     params: params
    //   })
    // }
    /** ********************楼凤列表************************* */
    // 获取楼凤列表
    getLouFengList(params) {
        return ajax({
            url: '/loufeng/list',
            type: 'post',
            params: params
        })
    },
    // 新增
    addLoufeng(params) {
        return ajax({
            url: '/loufeng/add',
            type: 'post',
            params: params
        })
    },
    // 修改
    updateLoufeng(params) {
        return ajax({
            url: '/loufeng/edit',
            type: 'post',
            params: params
        })
    },
    // 删除
    deleteLoufeng(params) {
        return ajax({
            url: '/loufeng/del',
            type: 'delete',
            params: params
        })
    },

    /** **************砸蛋活动流水********************* */
    // 获取砸蛋活动流水
    getWinRecord(params) {
        return ajax({
            url: '/sge/winRecord/list',
            type: 'get',
            params: params
        })
    },
    // 获取奖品名字列表
    getPrizeNames(params) {
        return ajax({
            url: '/sge/winRecord/prizeNames ',
            type: 'get',
            params: params
        })
    }
};

export default activeApi;
